// extracted by mini-css-extract-plugin
export var filterIncDec = "_9n-0";
export var leftBorder = "_9n-1";
export var rightBorder = "_9n-2";
export var stringInput = "_9n-3";